// extracted by css-extract-rspack-plugin
export default {"layout":"layout-QVZ3Eb","main":"main-ZRagP5","chatPane":"chatPane-QvYmA9","inputDock":"inputDock-qYYHlY","inputColumn":"inputColumn-T7jeD6"};